/**
 * List of states for a capital call
 */
export enum CapitalCallState {
    Requested = 'Requested',
    Submitted = 'Submitted',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Funded = 'Funded',
    Repaid = 'Repaid'
}